module.exports = __webpack_public_path__ + "img/2.4c97dde5.png";